import React from 'react';
const TongyongJiantouXia = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#3F465C';
    delete attribute.stroke;
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4 6L8 10L12 6", stroke: stroke, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default TongyongJiantouXia;
